import { Outlet, createFileRoute } from '@tanstack/react-router';
import { notFound } from '@tanstack/react-router';
import { Helmet } from 'react-helmet';

import { BreadcrumbSetter } from '@/components/BreadcrumbSetter';
import { LoadingSpinner } from '@/components/LoadingSpinner';
import { Navs } from '@/components/Navs';
import { ProductStatusAlert } from '@/components/products/specific/StatusAlert';
import { useProduct } from '@/hooks/data/useProducts';
import { productLinks, storeLinks } from '@/lib/links';

const navsForProductId = (productId: string) => {
	return [
		{ title: 'Analytics', href: productLinks.analytics(productId) },
		{ title: 'Properties', href: productLinks.properties(productId) },
		{ title: 'Revisions', href: productLinks.revisions(productId) },
		{ title: 'Reviews', href: productLinks.reviews(productId) },
		{ title: 'Settings', href: productLinks.settings(productId) },
	];
};

export const Route = createFileRoute('/products/$id')({
	component: function ProductLayout() {
		const { id } = Route.useParams();
		const { data: product, isLoading, isError } = useProduct(id);
		if (isLoading) return <LoadingSpinner />;
		if (isError || !product) throw notFound();

		return (
			<div className="space-y-4">
				{product.status !== 'ACTIVE' && <ProductStatusAlert status={product.status} />}
				<nav className="flex items-center gap-4">
					<Navs items={navsForProductId(id)} />
				</nav>
				<Outlet />
				<Helmet titleTemplate={`${product.name}'s %s`} defaultTitle={`${product.name} - Product`} />
				<BreadcrumbSetter
					items={[{ name: 'Products', href: storeLinks.products() }, { name: product?.name }]}
				/>
			</div>
		);
	},
});
